import { useEffect, useState } from "react";

interface Confetti {
  id: number;
  left: number;
  animationDuration: number;
  animationDelay: number;
  size: number;
  color: string;
  rotation: number;
  shape: 'circle' | 'square' | 'rectangle';
}

const CONFETTI_COLORS = [
  'hsl(var(--primary))',
  '#FFD700', // Gold
  '#FF6B6B', // Coral Red
  '#4ECDC4', // Teal
  '#FF69B4', // Hot Pink
  '#32CD32', // Lime Green
  '#FF8C00', // Dark Orange
  '#9370DB', // Medium Purple
];

const FestiveConfetti = () => {
  const [confetti, setConfetti] = useState<Confetti[]>([]);

  useEffect(() => {
    const particles: Confetti[] = Array.from({ length: 40 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      animationDuration: 4 + Math.random() * 8,
      animationDelay: Math.random() * 5,
      size: 6 + Math.random() * 10,
      color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
      rotation: Math.random() * 360,
      shape: (['circle', 'square', 'rectangle'] as const)[Math.floor(Math.random() * 3)],
    }));
    setConfetti(particles);
  }, []);

  const getShapeStyles = (particle: Confetti) => {
    const base = {
      backgroundColor: particle.color,
      transform: `rotate(${particle.rotation}deg)`,
    };
    
    switch (particle.shape) {
      case 'circle':
        return { ...base, borderRadius: '50%', width: particle.size, height: particle.size };
      case 'square':
        return { ...base, borderRadius: '2px', width: particle.size, height: particle.size };
      case 'rectangle':
        return { ...base, borderRadius: '2px', width: particle.size * 0.4, height: particle.size };
      default:
        return base;
    }
  };

  return (
    <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden">
      {confetti.map((particle) => (
        <div
          key={particle.id}
          className="absolute animate-snowfall"
          style={{
            left: `${particle.left}%`,
            animationDuration: `${particle.animationDuration}s`,
            animationDelay: `${particle.animationDelay}s`,
          }}
        >
          <div 
            className="shadow-sm"
            style={getShapeStyles(particle)}
          />
        </div>
      ))}
    </div>
  );
};

export default FestiveConfetti;
